import { render, staticRenderFns } from "./RedirectToMobileModal.vue?vue&type=template&id=179a8209&scoped=true&"
import script from "./RedirectToMobileModal.vue?vue&type=script&setup=true&lang=ts&"
export * from "./RedirectToMobileModal.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./RedirectToMobileModal.vue?vue&type=style&index=0&id=179a8209&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179a8209",
  null
  
)

export default component.exports